import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from './apiConfig';
import { useAuth } from "./AuthContext";
import occupationList from './occupations.json';
import { useNavigate } from 'react-router-dom';
import { containsForbiddenContactInfo } from './containsForbiddenContactInfo';


import './Search.css';

const BASE_IMG_URL = API_ENDPOINTS.BASEIMGURL;

function SearchPage() {
  const [results, setResults] = useState([]);
  const [page, setPage] = useState(1);
  const [minAge, setMinAge] = useState(0);
  const [maxAge, setMaxAge] = useState(0);
  const [loading, setLoading] = useState(false);
  const [popupUser, setPopupUser] = useState(null);
  const [imagePopupUser, setImagePopupUser] = useState(null)
  const [imageIndex, setImageIndex] = useState(0)
  const [validationError, setValidationError] = useState('')
 const [showFilterPopup, setShowFilterPopup] = useState(false);
   const [errors, setErrors] = useState([]);
   const [message, setMessage] = useState('');
   const [hasMore, setHasMore] = useState(true);
   const [noMoreMessage, setNoMoreMessage] = useState(false);
   const [messageText, setMessageText] = useState('');
const [sentMessages, setSentMessages] = useState({});
const [sendSuccess, setSendSuccess] = useState(false);
const [dailyCount, setDailyCount] = useState(0);
const [dailyLimit, setDailyLimit] = useState(4); // hardcoded limit
const [touchStartX, setTouchStartX] = useState(null);
const [touchEndX, setTouchEndX] = useState(null);
const [sending, setSending] = useState(false);
const navigate = useNavigate();
const [searchText, setSearchText] = useState('');
  const [error, setError] = useState('');
  const [messageError, setMessageError] = useState(false);

  

   const [formData, setFormData] = useState({
     name: '',
     dob: '',
     genderID: '',
     mstatusID: '',
     heightFt: '',
     heightIn: '',
     religionID: '',
     religion: '',
     casteID: '',
     caste: '',
     occupationID: '',
     occupation: '',
     salary: '',
     cityID: '',
     city: '',
     stateID: '',
     state: '',
     countryID: '',
     country: '',
     lstatusID: '',
     about: '',
   });


   const handleTouchStart = (e) => {
  setTouchStartX(e.targetTouches[0].clientX);
};

const handleTouchMove = (e) => {
  setTouchEndX(e.targetTouches[0].clientX);
};

const handleTouchEnd = () => {
  if (!touchStartX || !touchEndX) return;
  const diff = touchStartX - touchEndX;

  // Only respond to significant horizontal swipes
  if (Math.abs(diff) > 50) {
    if (diff > 0) {
      nextImage(); // Swipe left → next
    } else {
      prevImage(); // Swipe right → prev
    }
  }

  // Reset after swipe
  setTouchStartX(null);
  setTouchEndX(null);
};





 


 const handleSendMessage = async () => {

     if (containsForbiddenContactInfo(message)) {
      setError("⚠️ Do not share phone numbers, emails, or social media IDs. Violations may lead to blocking.");
      return;
    }


  if (!messageText.trim() || !popupUser?.id) return;

  try {
    await axios.post(
      API_ENDPOINTS.SENTMSG,
      {
        id: popupUser.id,
        text: messageText.trim(),
      },
      {
        headers: { token },
      }
    );

    setSentMessages((prev) => ({ ...prev, [popupUser.id]: messageText.trim() }));
    setMessageText('');
    setDailyCount((prev) => prev + 1);
  } catch (err) {
    console.error('Message send failed:', err);
  }
  finally {
    setSending(false);
    setTimeout(() => setSendSuccess(false), 3000);
  }
};

const fetchDailyCount = async () => {
  try {
    const res = await axios.post(API_ENDPOINTS.DAYMSGCOUNT, {}, {
      headers: { token },
    });

    if (res.data.result === 1) {
      setDailyCount(res.data.count || 0);
    }
  } catch (err) {
    console.error('Failed to fetch message count:', err);
  }
};



  // Handles react-select changes and sets IDs and clears manual input
  const handleSelectChange = (selected, idField, textField) => {
    if (selected?.value === '0') {
      setFormData((prev) => ({ ...prev, [idField]: '0', [textField]: '' }));
    } else {
      setFormData((prev) => ({ ...prev, [idField]: selected ? selected.value : '', [textField]: '' }));
    }
  };

  const makeOptions = (list) => [
    ...list.map((item) => ({ value: item.id.toString(), label: item.name })),
    { value: '0', label: 'Other' },
  ];

   

  const { token, logout } = useAuth();

const fetchResults = async (pageNum = 1) => {
  const Valid = await ValidateAge();

  if (Valid) {
    // ✅ Reset pagination and message when starting a fresh search
    if (pageNum === 1) {
      setHasMore(true);
      setNoMoreMessage(false);
    }

    setLoading(true);
    try {
      const payload = {
        minAge,
        maxAge,
        page: pageNum,
      };



       if (searchText.trim()) {
         payload.search = searchText.trim();
           }

      const res = await axios.post(API_ENDPOINTS.SEARCH, payload, {
        headers: { token: token },
      });


      if (res.data.result === 1 && Array.isArray(res.data.data)) {
        setResults(res.data.data);
        setPage(pageNum);

        if (res.data.data.length > 0) {
          setHasMore(true);
          setNoMoreMessage(false);
        } else {
          setHasMore(false);
          setNoMoreMessage(true); // ❗️ Show "no more results"
        }
      } else {
        setHasMore(false);
        setNoMoreMessage(true);
      }
    } catch (err) {
      console.error('Search error:', err);
    } finally {
      setLoading(false);
    }
  }
};


  const ValidateAge = async () => {
    if (minAge < 18 || maxAge < 18 || minAge > 99 || maxAge > 99) {
        setValidationError('Age must be between 18 and 99.');
        return false;
      } else if (maxAge - minAge > 5 || maxAge - minAge<0) {
        setMaxAge(minAge + 5);
        setValidationError('Age gap should not be more than 5 years.');
        return true
      } else {
        setValidationError('');
        return true
      }
  }



// This runs only once on page load
useEffect(() => {
  const fetchData = async () => {
    await fetchProfileImg();   // Only once
    fetchResults(1);           // Optional: can run here initially too
  };
  fetchDailyCount()
  fetchData();
}, []);

// This runs when minAge or maxAge changes
useEffect(() => {
  if (minAge && maxAge) {
    fetchResults(1);
  }
}, [minAge, maxAge]);


      const fetchProfileImg = async () => {
      try {
        const res = await axios.post(API_ENDPOINTS.GETPPHOTO, {}, {
          headers: { token },
        });

        if (res.data.result === 1 && res.data.detailResult === 1) {
         setMaxAge(res.data.age)
         var minAge=(res.data.age-5)
         if(minAge<18)
         {
          setMinAge(18)
         }
         else{
          setMinAge(minAge)
         }

        }
        else if(res.data.result === 0 && res.data.detailResult === 0)
        {
          navigate('/details');
          return;

        }
        else if(res.data.result === 0 && res.data.imgResult === 0)
        {
          navigate('/ProfileImageUpload');
          return;
        }


        
      } catch (err) {
        console.error('Error loading profile image:', err);
      }
    };


  const handleNextPage = () => {
    fetchResults(page + 1);
  };

  const handlePrevPage = () => {
    if (page > 1) fetchResults(page - 1);
  };

  const convertHeight = (cm) => {
    const ft = Math.floor(cm / 30.48);
    const inches = Math.round((cm / 2.54) % 12);
    return `${ft}' ${inches}"`;
  };



  const handleImageClick = (user, index) => {
    setImagePopupUser(user);
    setImageIndex(index);
  };

  const nextImage = () => {
    if (imagePopupUser && imagePopupUser.Img.length > 0) {
      setImageIndex((imageIndex + 1) % imagePopupUser.Img.length);
    }
  };

  const prevImage = () => {
    if (imagePopupUser && imagePopupUser.Img.length > 0) {
      setImageIndex((imageIndex - 1 + imagePopupUser.Img.length) % imagePopupUser.Img.length);
    }
  };

  return (
    <div
      className="d-flex flex-column min-vh-100"
      style={{
        background: 'linear-gradient(135deg, #ffe0f0, #d0e8ff)',
        padding: '1rem',
      }}
    >
  
<div className="text-center mt-3 mb-4 px-2">
  <h5
    className="fw-bold mb-3"
    style={{
      fontSize: '1.25rem',
      color: '#ff69b4',
      letterSpacing: '0.5px',
      textShadow: '0 1px 1px rgba(0,0,0,0.1)',
    }}
  >
    <i className="bi bi-search-heart-fill me-1" style={{ color: '#ff69b4' }}></i>
    Search Profiles
  </h5>

  {/* <div className="input-group input-group-sm shadow-sm mx-auto" style={{ maxWidth: 400 }}>
    <span className="input-group-text bg-white border-end-0">
      <i className="bi bi-search text-muted"></i>
    </span>
  <input
  type="text"
  className="form-control border-start-0"
  placeholder="Search by name, city, or ID"
  style={{ borderColor: '#ff69b4', borderRadius: '0 999px 999px 0' }}
  value={searchText}
  onChange={(e) => setSearchText(e.target.value)}
/>
</div> */}

</div>







<div className="container px-1">
  <div className="d-flex flex-column align-items-center text-center mb-3 w-100">

    <div className="row g-2 justify-content-center w-100 mb-2">

      {/* Min Age */}
      <div className="col-6" style={{ maxWidth: '140px' }}>
        <label htmlFor="minAge" className="form-label text-muted small mb-1">
          Min Age
        </label>
        <input
          id="minAge"
          type="number"
          min="18"
          max="99"
          className="form-control"
          placeholder="18"
          value={minAge}
          onChange={(e) => setMinAge(parseInt(e.target.value))}
        />
      </div>

      {/* Max Age */}
      <div className="col-6" style={{ maxWidth: '140px' }}>
        <label htmlFor="maxAge" className="form-label text-muted small mb-1">
          Max Age
        </label>
        <input
          id="maxAge"
          type="number"
          min="18"
          max="99"
          className="form-control"
          placeholder="99"
          value={maxAge}
          onChange={(e) => setMaxAge(parseInt(e.target.value))}
        />
      </div>

      {/* Search Button */}
      <div className="col-12 d-flex justify-content-center">
        <button
          className="btn px-4 py-2 rounded-pill d-flex align-items-center gap-2 shadow-sm"
          style={{
            backgroundColor: '#ff69b4',
            color: '#fff',
            fontWeight: 500,
            fontSize: '0.9rem',
          }}
          onClick={() => fetchResults(1)}
        >
          <i className="bi bi-search-heart-fill"></i> Search
        </button>
      </div>
    </div>

    {validationError && (
      <div className="text-danger small mt-1">
        {validationError}
      </div>
    )}
  </div>
</div>








      {loading && <div className="text-center my-4">Loading...</div>}

      <div className="profile-grid">
      {results.map((item) => (
        <div
          key={item.id}
          className="mb-3"
          style={{
            background: '#ffffffcc',
            cursor: 'pointer',
            borderRadius: '10px',
            overflow: 'hidden',
          }}
        >
          {item.Img?.length > 0 && (
              <div style={{ position: 'relative' }}>
            <img
              src={`${BASE_IMG_URL}${item.Img[0].Path}`}
              alt="Profile"
              onClick={() => handleImageClick(item, 0)}
              style={{
                width: '100%',
                height: 'auto',
                objectFit: 'cover',
              }}
            />
          <div
                className="position-absolute top-0 end-0 m-2 px-2 py-1 rounded-pill text-white shadow-sm"
                onClick={() => handleImageClick(item, 0)}
                style={{
                  backgroundColor: '#ff69b4',
                  fontSize: '0.75rem',
                  fontWeight: 500,
                }}
              >
                {item.Img.length} {item.Img.length > 1 ? '' : ''}
              </div>
            </div>
            
          )}

          <div className="p-1">
          

          <div className="p-1" style={{ fontSize: '0.95rem' }}>
  <h6 className="fw-bold mb-2"><span style={{ color: '#ff69b4' }}> {item.name}</span>, <span className="text-muted fw-normal">Age {item.age}</span></h6>

  <ul className="list-unstyled mb-2">
    <li className="mb-1">
      <i className="bi bi-rulers me-2 text-primary"></i>
      Height: <strong>{convertHeight(item.height)}</strong>
    </li>

    <li className="mb-1">
      <i className="bi bi-person-gear me-2 text-info"></i>
      Occupation: <strong>{
        item.occupationID
          ? (occupationList.find(r => r.id === item.occupationID)?.name || item.occupation)
          : item.occupation
      }</strong>
    </li>

    <li className="mb-1">
      <i className="bi bi-heart-pulse-fill me-2 text-danger"></i>
      Marital Status: <strong>{
        item.mstatusID === 0 ? 'Unmarried' :
        item.mstatusID === 1 ? 'Divorced' :
        item.mstatusID === 2 ? 'Widow' :
        item.mstatusID === 3 ? 'Married' : ''
      }</strong>
    </li>

    

  </ul>

  <p className="mt-2 text-muted">
    <i className="bi bi-chat-right-text-fill me-2"></i>
    <em>{item.about}</em>
  </p>
</div>     



<button
  className="btn d-flex align-items-center justify-content-center gap-2 rounded-pill shadow-sm"
  style={{
    backgroundColor: '#ff69b4',
    color: '#fff',
    padding: '6px 14px',
    fontSize: '14px',
    width: '100%',
    maxWidth: '180px',
    margin: '8px auto',
    opacity: sentMessages[item.id] ? 0.6 : 1,
    pointerEvents: sentMessages[item.id] ? 'none' : 'auto',
  }}
  onClick={() => setPopupUser(item)}
   disabled={!!sentMessages[item.id] || dailyCount >= dailyLimit}

>
  <i className="bi bi-chat-dots-fill" style={{ fontSize: '16px' }}></i>
 {dailyCount >= dailyLimit
  ? 'Daily Limit Exceeded'
  : sentMessages[item.id]
    ? 'Messaged'
    : `Message (${dailyLimit - dailyCount})`}
</button>





          </div>
        </div>
      ))}
 </div>
 
      {/* Pagination */}
 

 <div className="d-flex justify-content-between align-items-center my-3 px-2">
  <button
    className="btn d-flex align-items-center gap-2 rounded-pill shadow-sm"
    style={{ backgroundColor: '#ff69b4', color: '#fff', padding: '6px 14px', fontSize: '14px' }}
    disabled={page <= 1}
    onClick={handlePrevPage}
  >
    <i className="bi bi-arrow-left"></i>
    Previous
  </button>

  <button
    className="btn d-flex align-items-center gap-2 rounded-pill shadow-sm"
    style={{
      backgroundColor: '#ff69b4',
      color: '#fff',
      padding: '6px 14px',
      fontSize: '14px',
      opacity: hasMore ? 1 : 0.5,
      pointerEvents: hasMore ? 'auto' : 'none',
    }}
    onClick={handleNextPage}
    disabled={!hasMore}
  >
    Next
    <i className="bi bi-arrow-right"></i>
  </button>
</div>

{noMoreMessage && (
  <div className="text-center text-muted mt-2 small">
    <i className="bi bi-info-circle-fill me-2"></i>
    No more results found.
  </div>
)}



     


      {/* Message Popup - FULL SCREEN */}
      {popupUser && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column"
          style={{
            background: 'linear-gradient(135deg, #ffe0f0, #d0e8ff)',
            zIndex: 9999,
            padding: '1rem',
          }}
        >
          {/* Close Button */}
          <button
            className="btn-close position-absolute top-0 end-0 m-3"
            onClick={() => setPopupUser(null)}
          ></button>

          <div className="mt-5 text-center">
            <h4 className="mb-3">{popupUser.name}</h4>

            {popupUser.Img?.length > 0 && (
              <img
                src={`${BASE_IMG_URL}${popupUser.Img[0].Path}`}
                alt=""
                style={{
                  width: '100px',
                  height: '100px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                }}
                className="mb-3"

              />
            )}

      
{sentMessages[popupUser.id] ? (
  <div className="text-center">
    <div
      className="p-3 rounded shadow mb-3"
      style={{
        backgroundColor: '#fff',
        borderLeft: '5px solid #ff69b4',
        fontSize: '0.95rem',
        color: '#444',
      }}
    >
      <div className="mb-2 text-muted" style={{ fontSize: '0.8rem' }}>
        Your Message:
      </div>
      <div>"{sentMessages[popupUser.id]}"</div>
    </div>

    <div className="text-success fw-bold">
      <i className="bi bi-check-circle-fill me-2"></i>Message Sent
    </div>
  </div>
) : (
  <>
  <div
  className="mb-2 text-danger small d-flex align-items-start gap-2"
  style={{
    backgroundColor: '#fff3cd',
    border: '1px solid #ffeeba',
    padding: '10px',
    borderRadius: '8px',
    fontSize: '0.85rem',
    lineHeight: '1.4',
  }}
>
  <i className="bi bi-exclamation-triangle-fill mt-1" style={{ color: '#d39e00' }}></i>
  <div>
    <strong>Warning:</strong> Do not share phone numbers, email, or any contact/social handles (e.g. WhatsApp, Instagram, Facebook, Telegram, Snapchat, Twitter, LinkedIn, etc.).
    Violating this rule may result in your account being <strong>blocked.</strong>
    <strong>AI Engine will automatically allow contact sharing once a meaningful and respectful conversation has been established.</strong>
  </div>
</div>
    <textarea
      className="form-control mb-3"
      rows={5}
      placeholder="Type your message..."
      value={messageText}
        onChange={(e) => {
    const val = e.target.value;
    setMessageText(val);
    setMessageError(containsForbiddenContactInfo(val)); // assumes `setMessageError` is defined
  }}
      onKeyDown={(e) => {
    if (e.key === 'Enter' && !e.shiftKey && messageText.trim()) {
      e.preventDefault();
      handleSendMessage();
    }
  }}
    ></textarea>

{messageError && (
  <div className="text-danger small mb-3">
    ⚠️ Please don’t share phone numbers, emails, or social media IDs. Doing so may lead to your account being blocked. 
  </div>
)}

<button
  className="btn d-flex align-items-center justify-content-center gap-2 rounded-pill shadow-sm w-100"
  style={{
    backgroundColor: '#ff69b4',
    color: '#fff',
    padding: '8px 16px',
    fontSize: '15px',
    fontWeight: 500,
  }}
  onClick={handleSendMessage}
  disabled={
    !messageText.trim() ||
    dailyCount >= dailyLimit ||
    containsForbiddenContactInfo(messageText)
  }
>
  {dailyCount >= dailyLimit ? (
    <>
      <i className="bi bi-exclamation-triangle-fill"></i>
      Daily Limit Exceeded
    </>
  ) : (
    <>
      <i className="bi bi-envelope-fill"></i>
      Send Message ({dailyLimit - dailyCount})
    </>
  )}
</button>

  </>
)}


{sendSuccess && (
  <div
    className="alert alert-success text-center py-2 px-3 mt-3 animate__animated animate__fadeInDown"
    style={{ fontSize: '0.9rem' }}
  >
    <i className="bi bi-check-circle-fill me-2"></i>
    Message sent successfully!
  </div>
)}




          </div>
        </div>
      )}

      {/* Image Popup - FULL SCREEN */}
{imagePopupUser && (
  <div
    className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
    style={{
      backgroundColor: 'rgba(0, 0, 0, 0.95)',
      zIndex: 9999,
      padding: '1rem',
    }}
  >
    <div
      style={{
        textAlign: 'center',
        position: 'relative',
        maxWidth: '95vw',
      }}
    >
      {/* Close Button */}
      <button
        className="btn-close position-absolute top-0 end-0 m-2 bg-white rounded-circle p-2"
        onClick={() => setImagePopupUser(null)}
      ></button>

      {/* Image */}
      {imagePopupUser.Img?.length > 0 && (
        <img
          src={`${BASE_IMG_URL}${imagePopupUser.Img[imageIndex].Path}`}
          alt=""
          style={{
            maxWidth: '90vw',
            maxHeight: '80vh',
            objectFit: 'contain',
            borderRadius: '12px',
            boxShadow: '0 0 20px rgba(255,255,255,0.2)',
          }}
            onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
        />
      )}

      {/* Image Index */}
      {imagePopupUser.Img?.length > 1 && (
        <div className="text-white mt-2">
          Photo {imageIndex + 1} of {imagePopupUser.Img.length}
        </div>
      )}

      {/* Prev / Next Buttons */}
      {imagePopupUser.Img?.length > 1 && (
        <div className="d-flex justify-content-between align-items-center mt-3 px-2">
          <button
            className="btn d-flex align-items-center gap-2 rounded-pill shadow-sm"
            style={{ backgroundColor: '#ff69b4', color: '#fff', padding: '6px 14px', fontSize: '14px' }}
            onClick={prevImage}
          >
            <i className="bi bi-arrow-left-circle-fill"></i>
            Prev
          </button>

          <button
            className="btn d-flex align-items-center gap-2 rounded-pill shadow-sm"
            style={{ backgroundColor: '#ff69b4', color: '#fff', padding: '6px 14px', fontSize: '14px' }}
            onClick={nextImage}
          >
            Next
            <i className="bi bi-arrow-right-circle-fill"></i>
          </button>
        </div>
      )}
    </div>
  </div>
)}

</div>
  );
}

export default SearchPage;
